<template>
    <div class="header" :class="!$store.state.clientConfig.logo.usePrimaryBg ? 'nonTransparent' : 'transparent'">
        <div class="container">
            <nav class="navbar navbar-expand-lg justify-content-between">
                <div class="navbar-brand">
                    <img :src="`${$store.state.clientConfig.directoryUrl}/img/logo.png`" @click="routeHome" style="cursor:pointer"
                        :alt="$store.state.clientConfig.schemeName" />
                </div>
                <div class="navbar-toggler" data-toggle="collapse" @click="toggleNav" v-if="!hideInnerNav">
                    <span class="icon-menu"></span>
                </div>
                <div class="collapse navbar-collapse" :class="[{ 'show': showMenuMobile }, navOverride]" id="navbarSupportedContent" v-if="!hideInnerNav">
                    <ul class="navbar-nav mr-sm-2 text-center align-items-center">
                        <li class="nav-item active">
                            <router-link to="/" class="nav-link nav-link-fade-up" exact>Home</router-link>
                        </li>
                        <li class="nav-item" v-if="!isRegistrationAndLoginDisabled">
                            <router-link to="/my-pension/my-data" class="nav-link nav-link-fade-up" :class="{ 'router-link-active': myPensionActive }">My
                                Pension</router-link>
                        </li>
                        <li class="nav-item" v-if="!modellerOnly">
                            <router-link to="/information" class="nav-link nav-link-fade-up">{{ schemeOrFund }} Information</router-link>
                        </li>
                        <li class="nav-item" v-if="!modellerOnly">
                            <router-link to="/pension-news" class="nav-link nav-link-fade-up">News</router-link>
                        </li>

                        <li class="nav-item" v-if="!modellerOnly">
                            <router-link to="/links" class="nav-link nav-link-fade-up">Links</router-link>
                        </li>
                        <li class="nav-item" v-if="!modellerOnly">
                            <router-link to="/frequently-asked-questions" class="nav-link nav-link-fade-up">FAQs</router-link>
                        </li>
                        <li class="nav-item" v-if="loggedIn && !isRegistered && !isRegistrationAndLoginDisabled">

                            <router-link to="/register" class="nav-link nav-link-fade-up">Register</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/contact" class="nav-link nav-link-fade-up">Contact us</router-link>
                        </li>
                        <li class="nav-item" v-if="isLcpUser">
                            <router-link to="/admin" class="nav-link nav-link-fade-up">Admin</router-link>
                        </li>
                        <li class="nav-item" v-if="loggedIn">
                            <button class="nav-link nav-link-fade-up icon" v-tooltip="`Log out`" @click="logoutUser" aria-label="Log out">
                                Log out
                            </button>
                        </li>
                        <li class="nav-item" v-if="!loggedIn && !isRegistrationAndLoginDisabled">
                            <span class="nav-link nav-link-fade-up" @click="login" aria-label="Log in" style="cursor:pointer">
                                Log in
                            </span>
                        </li>
                    </ul>
                </div>

            </nav>
        </div>
    </div>
</template>

<script>
import authentication from '@/services/authentication';

export default {
    name: 'mainHeader',
    data () {
        return {};
    },
    props: {
        formSite: {
            type: Boolean,
            required: true,
        },
        modellerOnly: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        toggleNav () {
            this.$store.commit('toggleMenuMobile');
        },
        logoutUser () {
            authentication.signOut();
        },
        login () {
            authentication.init();
            this.$store.commit('analytics/setLoggingIn');
            authentication.signInSignUp();
        },
        routeHome () {
            if (!this.formSite) {
                this.$router.push('/');
            }
        },
    },
    computed: {
        loggedIn () {
            return this.$store.getters['auth/getAuthState'];
        },
        showMenuMobile () {
            return this.$store.state.ui.showMenuMobile;
        },
        myPensionActive () {
            return this.$route.path.indexOf('my-pension') > -1;
        },
        isLcpUser () {
            return this.$store.getters['auth/getIsLcpUser'];
        },
        hideInnerNav () {
            return this.$route.meta.hideInnerNav;
        },
        isRegistered () {
            return this.$store.getters['auth/getIsRegistered'];
        },
        schemeOrFund () {
            return this.$store.state.clientConfig.fundOrScheme;
        },
        navOverride () {
            return this.$store.state.clientConfig.colours.navFont !== undefined ? 'override' : '';
        },
        isRegistrationAndLoginDisabled () {
            return !!this.$store.state.clientConfig.disableRegistrationAndLogin;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";

.header {
    position: fixed;
    min-height: $nav-height;
    width: 100%;
    z-index: 12;
    box-shadow: 0 5px 10px -6px rgba(0, 0, 0, 0.1);


    &.transparent {
        color: var(--navFont);
        background: var(--navColour);

        .nav-link {
            color: var(--navFont);
        }

    }

    &.nonTransparent {
        background: white;
        color: var(--primaryColour);
        box-shadow: $boxShadow;

        .nav-link {
            color: var(--primaryColour);
        }
    }

    .navbar-brand {
        @include responsive("xs") {
            margin-right: 0;
        }

        img {
            max-height: 50px;
        }
    }

    button {
        background: none;
        border: 0;
    }

    .navbar-collapse {
        flex-grow: 0;
        transition: all 0.5s ease-in-out;

        .nav-item {
            position: relative;

            .nav-link {
                @include responsive("mdLandscape") {
                    padding: .3rem .5rem;
                    font-size: 14px;
                }

                @include responsive("ipadProPortrait") {
                    padding: .3rem .5rem;
                    font-size: 14px;
                }

                &.router-link-active {

                    // color:var(--secondaryColour);
                    &.nav-link-fade-up::before {
                        bottom: 0;
                        opacity: 1;
                    }
                }

                &.icon {
                    font-size: 16px;
                }
            }

            .nav-link::before {
                transition: 300ms;
                height: 3px;
                content: "";
                position: absolute;
                background-color: var(--secondaryColour);
            }

            .nav-link-fade-up::before {
                left: 10px;
                right: 10px;
                bottom: -10px;
                opacity: 0;
            }

            .nav-link-fade-up:hover::before {
                bottom: 0;
                opacity: 1;
            }
        }

        @include responsive("md") {
            height: 0;
            max-height: 0;
            opacity: 0;
            visibility: hidden;
        }

        &.show {
            height: 100%;
            max-height: 100vh;
            opacity: 1;
            display: block;
            visibility: visible;

            .nav-link-fade-up::before {
                left: 0px;
                right: 0px;
            }
        }

        &:not(.show) {
            display: block;
        }
    }
}
</style>
